import React from "react";
import "./AppLayout.css";
import { useLocation } from "react-router-dom";

const AppLayout = ({ children }) => {
  const location = useLocation();

  const noPaddingRoutes = [
    "/",
    "/login",
    "/sign-up",
    "/forgot-password",
    "/play-now-game",
    "/withdraw",
    "/bank-account",
    "/add-bank-account",
    "/withdrawal-history",
    "/usdt-deposit-history",
    "/usdt-addresses",
    "/deposite",
    "/deposite-history",
    "/self-service-center",
    "/invitation-bonus",
    "/invitation-record",
    "/betting-rebate",
    "/invite-wheel",
  ];

  const isInviteWheel = noPaddingRoutes.includes(location.pathname);

  return (
    <div className="app-layout" id="app-layout">
      <div
        className={`mobile-container ${
          isInviteWheel ? "no-bottom-padding" : ""
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default AppLayout;
